import React, { useState } from 'react';
import {
  FormControl,
  Grid, IconButton, InputAdornment, InputLabel, Link, MenuItem, Select,
  TextField
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import axios from 'axios';
import _ from 'lodash';
import { Autocomplete } from '@material-ui/lab';
import clsx from 'clsx';
import {LinkOutlined} from "@material-ui/icons";
import {validLinkedInUrl, validUrl} from "../../../../helpers/utils";
import EmailTextField from "../../shared/Inputs/EmailTextField";
import LinkIcon from "@material-ui/icons/Link";

const useStyles = makeStyles((theme) => ({
  root: {},
  fieldsRow: {
    marginBottom: '12px',
  },
  field: {
    '& label.Mui-focused': {
      color: '#000',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#000',
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#000',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#000',
      },
    },
  },
  inactiveCompany: {
    color: 'red',
  },
  associationLink: {
    position: 'absolute',
    top: '-10px',
    right: '10px',
    cursor: 'pointer',
    decoration: 'none',
    '&:hover': {
      decoration: 'none',
    }
  },
  inputWithAssociationLink: {
    position: 'relative',
  },
}))

const CurrentCompanyDataFields = ({ companyData, onChange, ...props }) => {
  const classes = useStyles();

  const [errorMessage, setErrorMessage] = useState('');

  const [phoneValue, setPhoneValue] = useState(companyData.phone || '');
  const [phoneExtValue, setPhoneExtValue] = useState(companyData.phone_ext || '');
  const [emailValue, setEmailValue] = useState(companyData.email || '');
  const [titleOptions, setTitleOptions] = useState(companyData?.title_id ? [{ id: companyData.title_id, name: companyData.title_name }] : []);
  const [openTitleAutocomplete, setOpenTitleAutocomplete] = useState(false);
  const [titleValue, setTitleValue] = useState(companyData?.title_id ? { id: companyData.title_id, name: companyData.title_name } : {})
  const [personalTeamPage, setPersonalTeamPage] = useState(companyData.personal_team_page || '')
  const [teamPageErrorMessage, setTeamPageErrorMessage] = useState('');

  const allowPrimaryRia = companyData.type_entity === 'RIA'
  const allowPrimaryBD = companyData.type_entity === 'BD' || companyData.type_entity === 'DR'

  const [primaryFirm, setPrimaryFirm] = useState(companyData.primary_firm ? 'Yes' : 'No');
  const [primaryRia, setPrimaryRia] = useState(allowPrimaryRia ? (companyData.primary_ria ? 'Yes' : 'No') : 'N/A');
  const [primaryBD, setPrimaryBD] = useState(allowPrimaryBD ? (companyData.primary_bd ? 'Yes' : 'No') : 'N/A');

  const handleNestedFieldChange = (event, item) => {
    onChange(event, item);
  }

  const handleYesNo = (event, item) => {
    switch (event.target.value) {
        case 'Yes':
            event.target.value = true;
            break;
        case 'No':
            event.target.value = false;
            break;
        default:
            event.target.value = null;
    }
    onChange(event, item);
  }

  const setValidPhoneNumber = (setPhoneNumber, event) => {
    const value = event.target.value
    const regExp = /^[+\-0-9(). ]+$/gi
    if (value === '' || regExp.test(value)) {
      setPhoneNumber(value)
    }
  }

  const handleOnChangeAutocomplete = (event, selectedValue) => {
    const originalSelected = selectedValue;
    const newSelectedValue = selectedValue ? selectedValue.id : null;

    const itemEvent = {
      target: {
        name: 'title_id',
        type: 'select',
        value: newSelectedValue,
      }
    }

    onChange(itemEvent, companyData);
    setTitleValue(originalSelected);
  }

  const handleInputChangeAutocomplete = (event) => {
    event.persist();
    if (event.target.value !== '' && event.target.value.length < 3){
      return
    }
    debounceFilterInput(event);
  }

  const debounceFilterInput = _.debounce((event) => {
    axios.get(
      `/v1/admin/titles/filter`,
      {
        params: { filter: event.target.value },
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': props.adminUserSession.email,
          'X-Admin-User-Token': props.adminUserSession.token
        }
      }
    ).then((response) => {
      const { status, titles } = response.data;

      if (status === 'ok') {
        setTitleOptions(titles);
      }
    });
  }, 650)

  const hadleOpen = (open) => {
    if (open === true){
      axios.get(
          `/v1/admin/titles/filter`,
          {
            params: { ids: titleValue.id },
            headers: {
              'Content-Type': 'multipart/form-data',
              'X-Admin-User-Email': props.adminUserSession.email,
              'X-Admin-User-Token': props.adminUserSession.token
            }
          }
      ).then((response) => {
        const { status, titles } = response.data;

        if (status === 'ok') {
          if (open === true) {
            setTitleOptions(titles);
          }
          setOpenTitleAutocomplete(open)
        }
      });
    } else {
      setOpenTitleAutocomplete(false)
    }

  }

  const validateEmailFormat = (event) => {
    event.persist();

    const { value } = event.target;
    const regExp = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/gi

    if (value !== '') {
      if (!regExp.test(value)) {
        setErrorMessage('Invalid email format');
      } else {
        setErrorMessage('');
        onChange(event, companyData);
      }
    } else {
      onChange(event, companyData);
    }
  }

  const validateUrlFormat = (event) => {
    event.persist();

    const { value } = event.target;

    if (value !== '') {
      if (!validUrl(value)) {
        setTeamPageErrorMessage('Invalid url format');
      } else {
        setTeamPageErrorMessage('');
        onChange(event, companyData);
      }
    } else {
      onChange(event, companyData);
    }
  }

  const { id, primary_business_name, type_entity, active } = companyData;

  return (
    <React.Fragment>
      <Grid container spacing={3} key={id} className={classes.fieldsRow}>
        <Grid item container md={2} spacing={3}>
          <Grid
              item
              md={12}
              xs={12}
          >
            <div className={clsx({ [classes.inactiveCompany]: !active })}>
              {primary_business_name}
            </div>
          </Grid>
        </Grid>
        <Grid item container md={10} spacing={3}>
          <Grid
              item
              md={2}
              xs={12}
          >
            <TextField
                fullWidth
                label="Office Phone Number"
                name="phone"
                onChange={(event) => setValidPhoneNumber(setPhoneValue, event)}
                onBlur={(e) => handleNestedFieldChange(e, companyData)}
                value={phoneValue}
                variant="outlined"
                className={classes.field}
            />
          </Grid>
          <Grid
              item
              md={2}
              xs={12}
          >
            <TextField
                fullWidth
                label="EXT Office Phone Number"
                name="phone_ext"
                onChange={(event) => setValidPhoneNumber(setPhoneExtValue, event)}
                onBlur={(event) => handleNestedFieldChange(event, companyData)}
                value={phoneExtValue}
                variant="outlined"
                className={classes.field}
            />
          </Grid>
          <Grid
              item
              md={2}
              xs={12}
          >
            <TextField
                fullWidth
                label="Email"
                name="email"
                onChange={(event) => setEmailValue(event.target.value)}
                onBlur={(event) => validateEmailFormat(event, companyData)}
                value={emailValue}
                variant="outlined"
                className={classes.field}
            />
            {errorMessage}
          </Grid>
          <Grid
              item
              md={2}
              xs={12}
          >
            <Autocomplete
                id={`title_id_${id}`}
                open={openTitleAutocomplete}
                onOpen={(event) => hadleOpen(true)}
                onClose={(event) => hadleOpen(false)}
                onChange={(event, value) => handleOnChangeAutocomplete(event, value)}
                // getOptionSelected={(option, value) => option.id === value.id}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.name || ''}
                value={titleValue}
                options={titleOptions}
                className={classes.field}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Title"
                        variant="outlined"
                        onChange={(event) => handleInputChangeAutocomplete(event)}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                              <React.Fragment>
                                {/* {loadingAchievements ? <CircularProgress color="inherit" size={20} /> : null} */}
                                {/*change the loading or remove*/}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                          ),
                        }}
                    />
                )}
            />
          </Grid>
          <Grid
              item
              md={2}
              xs={12}
              className={classes.inputWithAssociationLink}
          >
            <React.Fragment>
              {personalTeamPage ? <Link href={personalTeamPage} target='_blank' rel='noreferrer' className={classes.associationLink}><LinkOutlined /></Link> : ''}
              <TextField
                  fullWidth
                  label="Personal Team Page"
                  name="personal_team_page"
                  onChange={(event) => setPersonalTeamPage(event.target.value)}
                  onBlur={(event) => validateUrlFormat(event, companyData)}
                  value={personalTeamPage}
                  variant="outlined"
                  className={classes.field}
                  inputProps={{
                    maxLength: 255
                  }}
              />
              {teamPageErrorMessage}
              {/*<span style={{color: 'red', fontSize: '14px', fontWeight: '400'}}>{teamPageErrorMessage}</span>*/}
            </React.Fragment>
          </Grid>

          {(props.adminUserSession.isSuperAdmin || props.adminUserSession.inHouseResearch) &&
              (
                  <>
                    <Grid item md={2} xs={12}>
                      <React.Fragment>
                        <FormControl fullWidth>
                          <TextField
                              select
                              fullWidth
                              value={primaryFirm}
                              name='primary_firm'
                              onChange={(event) => setPrimaryFirm(event.target.value)}
                              onBlur={(event) => handleYesNo(event, companyData) }
                              label='Primary Firm'
                              variant='outlined'
                          >
                            <MenuItem key="none" value=""></MenuItem>)
                            <MenuItem key="firm_T" value="Yes">Yes</MenuItem>)
                            <MenuItem key="firm_F" value="No">No</MenuItem>)
                          </TextField>
                        </FormControl>
                      </React.Fragment>
                    </Grid>

                    <Grid item md={2} xs={12}>
                      <React.Fragment>
                        <FormControl fullWidth>
                          <TextField
                              select
                              fullWidth
                              value={primaryRia}
                              name='primary_ria'
                              onChange={(event) => setPrimaryRia(event.target.value)}
                              onBlur={(event) => handleYesNo(event, companyData) }
                              label='Primary Ria'
                              variant='outlined'
                          >
                            {allowPrimaryRia ? ['Yes', 'No'].map((item) =>
                                    <MenuItem key={`ria_${item}`} value={item}>{item}</MenuItem>) :
                                <MenuItem key="ria_none" value="">N/A</MenuItem>
                            }
                          </TextField>
                        </FormControl>
                      </React.Fragment>
                    </Grid>

                    <Grid item md={2} xs={12}>
                      <React.Fragment>
                        <FormControl fullWidth>
                          <TextField
                              select
                              fullWidth
                              value={primaryBD}
                              name='primary_bd'
                              onChange={(event) => setPrimaryBD(event.target.value)}
                              onBlur={(event) => handleYesNo(event, companyData) }
                              label='Primary BD'
                              variant='outlined'
                          >
                            {allowPrimaryBD ? ['Yes', 'No'].map((item) =>
                                    <MenuItem key={`bd_${item}`} value={item}>{item}</MenuItem>) :
                                <MenuItem key="bd_none" value="">N/A</MenuItem>
                            }
                          </TextField>
                        </FormControl>
                      </React.Fragment>
                    </Grid>
                    <Grid item md={2} xs={12}>
                      <React.Fragment>
                        <div style={{fontSize: '14px', fontWeight: '100'}}>Auto/Manual</div>
                        <div style={{marginTop: '10px'}}>{companyData.automatic_primary_firm ? 'Automatic' : 'Manual'}</div>
                      </React.Fragment>
                    </Grid>

                  </>
              )
          }

          <Grid
              item
              md={2}
              xs={12}
          >
            <TextField
                fullWidth
                label="Automated Email"
                name="automated_email"
                value={companyData.automated_email}
                variant="outlined"
                className={classes.field}
                maxLength={40}
                dataSet={'RIA'}
                disabled // Disabled because this is an automated field
                InputProps={{
                  endAdornment: <InputAdornment position="end">
                    <IconButton
                        aria-label="go to site"
                        edge="end"
                    >
                      {
                        !_.isEmpty(companyData.automated_source) ? <Link href={companyData.automated_source} target={"_blank"}>
                          <LinkIcon />
                        </Link> : <LinkIcon />
                      }
                    </IconButton>
                  </InputAdornment>
                }}
            />
          </Grid>
          <Grid
              item
              md={2}
              xs={12}
          >
            <TextField
                fullWidth
                label="Automated Phone"
                name="automated_phone"
                value={companyData.automated_phone}
                variant="outlined"
                className={classes.field}
                disabled // Disabled because this is an automated field
                InputProps={{
                  endAdornment: <InputAdornment position="end">
                    <IconButton
                        aria-label="go to site"
                        edge="end"
                    >
                      {
                        !_.isEmpty(companyData.automated_source) ? <Link href={companyData.automated_source} target={"_blank"}>
                          <LinkIcon />
                        </Link> : <LinkIcon />
                      }
                    </IconButton>
                  </InputAdornment>
                }}
            />
          </Grid>
          <Grid
              item
              md={2}
              xs={12}
              className={classes.inputWithAssociationLink}
          >
            <TextField
                fullWidth
                label="Automated Title"
                name="automated_title_name"
                value={companyData.automated_title_name}
                variant="outlined"
                className={classes.field}
                disabled // Disabled because this is an automated field
                InputProps={{
                  endAdornment: <InputAdornment position="end">
                    <IconButton
                        aria-label="go to site"
                        edge="end"
                    >
                      {
                        !_.isEmpty(companyData.automated_source) ? <Link href={companyData.automated_source} target={"_blank"}>
                          <LinkIcon />
                        </Link> : <LinkIcon />
                      }
                    </IconButton>
                  </InputAdornment>
                }}
            />
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  )
}

export default CurrentCompanyDataFields;
